module.exports = __webpack_public_path__ + "img/price-comparison.6949447d.svg";